/* Seven Sajada design layer: header, hover menus, drawer, hero slideshow, filters, swatches, quotes, couple set.
   Loaded after Impulse's theme.js (both deferred), so theme.CartDrawer and theme.Drawers already exist. */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }

  /* ---------- header: transparent over the hero, solid elsewhere ---------- */
  function initHeader() {
    var header = qs('.ss-header');
    if (!header) return;
    var hero = qs('.ss-hero');
    function update() {
      var y = window.scrollY || window.pageYOffset;
      var over = !!hero && document.body.classList.contains('ss-has-hero') &&
        y < hero.offsetTop + hero.offsetHeight - header.offsetHeight * 2;
      document.body.classList.toggle('ss-over', over);
      header.classList.toggle('is-scrolled', !over && y > 4);
    }
    on(window, 'scroll', update, {passive: true});
    on(window, 'resize', update);
    update();

    /* hover menus (desktop) */
    var mega = qs('#SsMega');
    var links = qsa('.ss-nav a', header);
    var timer = null, openKey = null;
    var warmed = false;
    function warm() {  // fetch the panel photos on the first approach to the menu, not on every page load
      if (warmed || !mega) return; warmed = true;
      qsa('img[loading="lazy"]', mega).forEach(function (im) { im.loading = 'eager'; });
    }
    on(qs('.ss-nav', header), 'mouseenter', warm);
    function openMega(key) {
      clearTimeout(timer);
      if (!mega) return;
      warm();
      qsa('[data-panel]', mega).forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== key; });
      mega.hidden = false; openKey = key;
      document.body.classList.add('ss-mega-open');
      links.forEach(function (a) { if (a.dataset.mega) a.setAttribute('aria-expanded', String(a.dataset.mega === key)); });
    }
    function closeMega() {
      clearTimeout(timer); openKey = null;
      if (mega) mega.hidden = true;
      document.body.classList.remove('ss-mega-open');
      links.forEach(function (a) { if (a.dataset.mega) a.setAttribute('aria-expanded', 'false'); });
    }
    function closeSoon() { clearTimeout(timer); timer = setTimeout(closeMega, 180); }
    links.forEach(function (a) {
      on(a, 'mouseenter', function () { if (!canHover) return; if (a.dataset.mega) openMega(a.dataset.mega); else closeSoon(); });
      on(a, 'focus', function () { if (a.dataset.mega) openMega(a.dataset.mega); else closeMega(); });
      // first tap on a touch laptop opens the menu, the second follows the link
      on(a, 'click', function (e) { if (a.dataset.mega && !canHover && openKey !== a.dataset.mega) { e.preventDefault(); openMega(a.dataset.mega); } });
    });
    qsa('.ss-logo, .ss-tools', header).forEach(function (el) { on(el, 'mouseenter', closeSoon); });
    on(header, 'mouseleave', closeSoon);
    on(mega, 'mouseenter', function () { clearTimeout(timer); });
    on(header, 'focusout', function (e) { if (!header.contains(e.relatedTarget)) closeMega(); });

    /* search panel */
    var search = qs('#SsSearch');
    qsa('[data-ss-search-toggle]').forEach(function (b) {
      on(b, 'click', function (e) {
        e.preventDefault();
        if (!search) { location.href = b.getAttribute('href') || '/search'; return; }
        search.hidden = !search.hidden;
        b.setAttribute('aria-expanded', String(!search.hidden));
        if (!search.hidden) { closeMega(); var i = qs('input', search); if (i) i.focus(); }
      });
    });

    /* phone drawer */
    var drawer = qs('#SsDrawer'), opener = qs('[data-ss-menu-open]');
    function openDrawer() { if (!drawer) return; drawer.hidden = false; document.documentElement.style.overflow = 'hidden'; if (opener) opener.setAttribute('aria-expanded', 'true'); var c = qs('[data-ss-menu-close]', drawer); if (c) c.focus(); }
    function closeDrawer() { if (!drawer || drawer.hidden) return; drawer.hidden = true; document.documentElement.style.overflow = ''; if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); } }
    on(opener, 'click', openDrawer);
    qsa('[data-ss-menu-close]').forEach(function (b) { on(b, 'click', closeDrawer); });

    on(document, 'keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeMega(); closeDrawer();
      if (search && !search.hidden) search.hidden = true;
    });

    /* currency / country selector submits on change */
    qsa('[data-ss-localization] select').forEach(function (s) { on(s, 'change', function () { s.form.submit(); }); });
  }

  /* ---------- cart drawer (Impulse) without the Impulse header ---------- */
  function initCart() {
    var count = qs('[data-ss-cart-count]');
    function setCount(n) { if (!count) return; count.textContent = n; count.setAttribute('data-count', n); }
    function refresh() {
      fetch((window.theme && theme.routes && theme.routes.cart) || '/cart.js', {credentials: 'same-origin'})
        .then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
    }
    on(document, 'cart:updated', function (e) { if (e.detail && e.detail.cart) setCount(e.detail.cart.item_count); else refresh(); });
    on(document, 'ajaxProduct:added', function () { setTimeout(refresh, 250); });
    if (window.theme && theme.CartDrawer && theme.settings && theme.settings.cartType === 'drawer' &&
        qs('#CartDrawer') && !document.body.classList.contains('template-cart')) {
      try { theme.ssCartDrawer = new theme.CartDrawer(); } catch (err) { /* the cart page link still works */ }
    }
  }

  /* ---------- hero slideshow ---------- */
  function initHero(root) {
    var slides = qsa('.ss-slide', root);
    var dots = qsa('.ss-dots button', root);
    var label = qs('.ss-slide-label', root), labelText = label && qs('em', label);
    if (slides.length < 2) return;
    var ms = parseInt(root.getAttribute('data-ms'), 10) || 6500, i = 0, t = null;
    root.style.setProperty('--ss-slide-ms', ms + 'ms');
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-on', j === i); s.setAttribute('aria-hidden', String(j !== i)); });
      dots.forEach(function (d, j) {
        d.classList.remove('is-on', 'is-done'); void d.offsetWidth;
        if (j < i) d.classList.add('is-done');
        if (j === i) d.classList.add(reduceMotion ? 'is-done' : 'is-on');
        d.setAttribute('aria-current', String(j === i));
      });
      var s = slides[i];
      if (label) {
        label.hidden = !s.dataset.label;
        label.setAttribute('href', s.dataset.href || '#');
        if (labelText) labelText.textContent = s.dataset.label || '';
      }
      // load the next image ahead of time
      var next = slides[(i + 1) % slides.length], img = next && qs('img[loading="lazy"]', next);
      if (img) img.loading = 'eager';
      clearTimeout(t);
      if (!reduceMotion && !document.hidden) t = setTimeout(function () { go(i + 1); }, ms);
    }
    dots.forEach(function (d, j) { on(d, 'click', function () { go(j); }); });
    on(document, 'visibilitychange', function () { if (document.hidden) clearTimeout(t); else go(i); });
    go(0);
  }

  /* ---------- product cards: the second photo appears on hover, colour dots swap photos ---------- */
  function hoverPhoto(link) {
    if (!link || qs('.ss-card__b', link) || !link.dataset.hoverSrc) return;
    var img = document.createElement('img');
    img.className = 'ss-card__b'; img.alt = ''; img.decoding = 'async';
    img.sizes = link.dataset.hoverSizes || '25vw';
    img.srcset = link.dataset.hoverSrcset || '';
    img.src = link.dataset.hoverSrc;
    link.appendChild(img);
  }
  if (canHover) {
    on(document, 'pointerover', function (e) {
      var link = e.target.closest && e.target.closest('.ss-card__img');
      if (link) hoverPhoto(link);
    });
  }
  function pickSwatch(btn) {
    var card = btn.closest('.ss-card'); if (!card) return;
    var a = qs('.ss-card__a', card), b = qs('.ss-card__b', card), link = qs('.ss-card__img', card);
    if (a && btn.dataset.a) { a.srcset = btn.dataset.aSet || ''; a.src = btn.dataset.a; a.alt = btn.dataset.alt || a.alt; }
    if (btn.dataset.b) {
      if (b) { b.srcset = btn.dataset.bSet || ''; b.src = btn.dataset.b; }
      else if (link) { link.dataset.hoverSrc = btn.dataset.b; link.dataset.hoverSrcset = btn.dataset.bSet || ''; }
    }
    qsa('[data-ss-card-link]', card).forEach(function (l) { if (btn.dataset.url) l.href = btn.dataset.url; });
    qsa('.ss-msw button', card).forEach(function (x) { x.setAttribute('aria-pressed', String(x === btn)); });
    // a colour beyond the five visible dots takes the place of the fifth
    var all = qsa('.ss-msw button', card);
    if (all.length > 5) all.forEach(function (x, j) { x.hidden = j >= 5 ? x !== btn : (all.indexOf(btn) >= 5 && j === 4); });
  }
  on(document, 'click', function (e) {
    var b = e.target.closest && e.target.closest('.ss-msw button');
    if (b) { e.preventDefault(); pickSwatch(b); }
  });

  /* ---------- filter chips + sort (collection grid, tasbih grid) ---------- */
  function initFilter(root) {
    var grid = qs('[data-ss-grid]', root) || root;
    var chips = qsa('.ss-chip', root);
    var sort = qs('[data-ss-sort]', root);
    var countEl = qs('[data-ss-count]', root);
    var extras = qsa('[data-ss-extra]', grid);
    function apply(v) {
      var shown = 0;
      qsa('[data-ss-item]', grid).forEach(function (item) {
        var tags = (' ' + (item.getAttribute('data-tags') || '') + ' ');
        var hit = v === 'all' || tags.indexOf(' ' + v + ' ') !== -1;
        item.hidden = !hit;
        if (hit) shown++;
        // show a matching colour on mats that come in several colours
        if (hit && v !== 'all' && item.hasAttribute('data-ss-colours')) {
          var sw = qs('.ss-msw button[data-group="' + v + '"]', item);
          if (sw) pickSwatch(sw);
        }
      });
      extras.forEach(function (x) { x.hidden = v !== 'all'; });
      chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c.dataset.v === v)); });
      if (countEl) {
        var one = countEl.getAttribute('data-one') || '', many = countEl.getAttribute('data-many') || '';
        countEl.textContent = (shown === 1 ? one : many).replace('[count]', shown);
      }
    }
    chips.forEach(function (c) { on(c, 'click', function () { apply(c.dataset.v); }); });
    on(sort, 'change', function () {
      var items = qsa('[data-ss-item]', grid), mode = sort.value;
      items.sort(function (x, y) {
        if (mode === 'price-asc') return (+x.dataset.price) - (+y.dataset.price) || (+x.dataset.index) - (+y.dataset.index);
        if (mode === 'price-desc') return (+y.dataset.price) - (+x.dataset.price) || (+x.dataset.index) - (+y.dataset.index);
        return (+x.dataset.index) - (+y.dataset.index);
      });
      var anchor = extras[0] || null;
      items.forEach(function (it) { grid.insertBefore(it, anchor); });
    });
    var start = 'all';
    try { var p = new URLSearchParams(location.search).get('filter'); if (p && chips.some(function (c) { return c.dataset.v === p; })) start = p; } catch (err) {}
    apply(start);
  }

  /* ---------- colour switcher (one design, many colours) ---------- */
  function initSwitch(root) {
    var main = qs('[data-ss-switch-main]', root), inset = qs('[data-ss-switch-inset]', root);
    var name = qs('[data-ss-switch-name]', root), link = qs('[data-ss-switch-link]', root);
    qsa('.ss-sw', root).forEach(function (b) {
      on(b, 'click', function () {
        qsa('.ss-sw', root).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        if (name) name.textContent = b.dataset.name;
        if (main && b.dataset.a) { main.srcset = b.dataset.aSet || ''; main.src = b.dataset.a; main.alt = b.dataset.alt || ''; }
        if (inset && b.dataset.b) { inset.srcset = b.dataset.bSet || ''; inset.src = b.dataset.b; }
        if (link && b.dataset.url) link.href = b.dataset.url;
      });
    });
  }

  /* ---------- quote carousel ---------- */
  function initQuotes(root) {
    var items = qsa('[data-ss-quote]', root), dots = qsa('.ss-qdots i', root), i = 0;
    if (items.length < 2) return;
    function show(n) {
      i = (n + items.length) % items.length;
      items.forEach(function (q, j) { q.hidden = j !== i; });
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
    }
    on(qs('[data-ss-prev]', root), 'click', function () { show(i - 1); });
    on(qs('[data-ss-next]', root), 'click', function () { show(i + 1); });
    show(0);
  }

  /* ---------- product page: couple set + add-on ---------- */
  function initProductExtras() {
    var couple = qs('[data-ss-couple]'), addon = qs('[data-ss-addon]');
    if (!couple && !addon) return;
    var coupleId = null;
    if (couple) {
      var cb = qs('input[type="checkbox"]', couple), pick = qs('.ss-couple__pick', couple);
      var nameEl = qs('[data-ss-couple-name]', couple), pairB = qs('[data-ss-pair-b]', couple), pairBName = qs('[data-ss-pair-b-name]', couple);
      var pairA = qs('[data-ss-pair-a]', couple), pairAName = qs('[data-ss-pair-a-name]', couple);
      var btns = qsa('.ss-sw', couple);
      function choose(b) {
        btns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        coupleId = b.dataset.id;
        if (nameEl) nameEl.textContent = b.dataset.name;
        if (pairB) { pairB.src = b.dataset.img; pairB.alt = b.dataset.alt || ''; }
        if (pairBName) pairBName.textContent = b.dataset.name;
      }
      btns.forEach(function (b) { on(b, 'click', function () { choose(b); }); });
      on(cb, 'change', function () { pick.hidden = !cb.checked; });
      var inStock = btns.filter(function (b) { return !b.hasAttribute('data-soldout'); });
      var first = inStock[1] || inStock[0] || btns[1] || btns[0];
      if (first) choose(first);
      // keep the first mat in the pair in sync with the main colour picker
      on(document, 'variant:change', function (e) {
        var v = e.detail && e.detail.variant; if (!v) return;
        var match = btns.filter(function (b) { return b.dataset.id === String(v.id); })[0];
        if (match && pairA) { pairA.src = match.dataset.img; pairA.alt = match.dataset.alt || ''; }
        if (match && pairAName) pairAName.textContent = match.dataset.name;
        if (match && coupleId === match.dataset.id) {
          var other = btns.filter(function (b) { return b !== match && !b.hasAttribute('data-soldout'); })[0] || btns.filter(function (b) { return b !== match; })[0];
          if (other) choose(other);
        }
      });
    }
    on(document, 'ajaxProduct:added', function (e) {
      var form = e.detail && e.detail.addToCartBtn && e.detail.addToCartBtn.closest('form');
      if (!form || !form.closest('[data-ss-pdp]')) return;
      var items = [];
      var qtyInput = qs('input[name="quantity"]', form), qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      var coupleBtn = couple && qs('.ss-sw[data-id="' + coupleId + '"]', couple);
      if (coupleBtn && !coupleBtn.hasAttribute('data-soldout') && qs('input[type="checkbox"]', couple).checked) items.push({id: +coupleId, quantity: qty});
      if (addon && qs('input[type="checkbox"]', addon).checked && addon.dataset.id) items.push({id: +addon.dataset.id, quantity: 1});
      if (!items.length) return;
      fetch(((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js'), {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
        body: JSON.stringify({items: items})
      }).then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
        setTimeout(function () {
          fetch('/cart.js', {credentials: 'same-origin'}).then(function (r) { return r.json(); }).then(function (c) {
            document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: c}}));
          });
        }, 300);
      }).catch(function () {});
    });
  }

  /* ---------- phone buy bar: appears once the main add-to-cart button scrolls away ---------- */
  function initBuybar() {
    var pdp = qs('[data-ss-pdp]'); if (!pdp) return;
    var btn = qs('form[action*="/cart/add"] [data-add-to-cart]', pdp) || qs('.add-to-cart', pdp);
    var title = qs('.product-single__title', pdp);
    if (!btn || !title) return;
    var bar = document.createElement('div');
    bar.className = 'ss ss-buybar'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<span class="ss-buybar__img"></span><span class="ss-buybar__text"><b></b><small class="ss-price"></small></span><button type="button" class="ss-btn" tabindex="-1"></button>';
    if (pdp.dataset.ssImg) { var im = document.createElement('img'); im.src = pdp.dataset.ssImg; im.alt = ''; qs('.ss-buybar__img', bar).appendChild(im); }
    qs('b', bar).textContent = title.textContent.trim();
    var bbtn = qs('button', bar), price = qs('small', bar);
    function sync() {
      bbtn.textContent = (qs('[data-add-to-cart-text]', btn) || btn).textContent.trim();
      bbtn.disabled = btn.disabled;
      var p = qs('[data-product-price]', pdp); price.textContent = p ? p.textContent.trim() : '';
    }
    bbtn.addEventListener('click', function () { if (!btn.disabled) btn.click(); });
    document.body.appendChild(bar);
    function update() {
      var show = btn.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-on', show); bar.setAttribute('aria-hidden', String(!show)); bbtn.tabIndex = show ? 0 : -1;
    }
    on(window, 'scroll', update, {passive: true});
    on(document, 'variant:change', function () { setTimeout(sync, 50); });
    sync(); update();
  }

  /* ---------- background videos load and play only when they near the screen ---------- */
  function initLazyVideos() {
    var vids = qsa('video[data-ss-lazy-video]');
    if (!vids.length) return;
    var saveData = navigator.connection && navigator.connection.saveData;
    if (reduceMotion || saveData) return; // the poster image stays
    function start(v) {
      if (v.dataset.loaded) return;
      v.dataset.loaded = '1';
      v.src = v.dataset.src;
      v.load();
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { start(en.target); io.unobserve(en.target); }
      });
    }, {rootMargin: '300px 0px'});
    vids.forEach(function (v) { io.observe(v); });
  }

  function init() {
    initHeader();
    initBuybar();
    initCart();
    qsa('[data-ss-hero]').forEach(initHero);
    qsa('[data-ss-filter]').forEach(initFilter);
    qsa('[data-ss-switch]').forEach(initSwitch);
    qsa('[data-ss-quotes]').forEach(initQuotes);
    initProductExtras();
    initLazyVideos();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* theme editor: re-run when a section is added or changed */
  on(document, 'shopify:section:load', function (e) {
    var t = e.target;
    qsa('[data-ss-hero]', t).forEach(initHero);
    qsa('[data-ss-filter]', t).forEach(initFilter);
    qsa('[data-ss-switch]', t).forEach(initSwitch);
    qsa('[data-ss-quotes]', t).forEach(initQuotes);
  });
})();
